// extracted by mini-css-extract-plugin
export default {"LiveChat":"LiveChat_LiveChat__QoauN","button":"LiveChat_button__Ni4DX","Img":"LiveChat_Img__BC3Dj"};